export class EventTypeInputGroupItem {
    constructor(eventTypeInputGroupItemId: number, eventTypeInputGroupId: number, eventTypeInputId: number, itemOrder: number) {
        this.eventTypeInputGroupItemId = eventTypeInputGroupItemId;
        this.eventTypeInputGroupId = eventTypeInputGroupId;
        this.eventTypeInputId = eventTypeInputId;
        this.itemOrder = itemOrder;
    }
    eventTypeInputGroupItemId: number;
    eventTypeInputGroupId: number;
    eventTypeInputId: number;
    itemOrder: number;
}
